import React, { useEffect } from "react";
import Headers from "./Headers";
import Join from "../../Join";
import Footer from "../../Footer";
import ComplaintsForm from "./ComplaintsForm";

const Supports = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);
  return (
    <>
      <Headers />
      <ComplaintsForm />
      <Join />
      <Footer />
    </>
  );
};

export default Supports;
